import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { Survey } from '../../../../../classes';
import { Subscription } from 'rxjs';
@Component({
  selector: 'survey-title',
  templateUrl: './survey-title.component.html',
  styleUrls: ['./survey-title.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SurveyTitleComponent implements OnInit {
  @Input() survey: Survey;
  subscriptions: Subscription[] = [];

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.subscriptions.push(
      this.survey
        .getChildTracker('title')
        .onContentUpdate.subscribe(() => this.cdRef.detectChanges())
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
